import { useMutation } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { EndPoints } from '../model/constants';
import { AccessTokenAuth } from '../auth/AccessTokenAuth';
import UserService from './UserService';

export default function SetPasswordService() {
    const { promotionSlug, user } = useSelector(state => state.configurator);
    const dispatch = useDispatch();
    const userMutation = UserService();

    return useMutation(['setPasswordQuery'], (payload) => {
        const setPasswordUrl = `${EndPoints.SetPasswordUrl}/${promotionSlug}/set-password`;
        const data = {
            promotion_slug: promotionSlug,
            password: payload.password,
        };
        const config = {
            headers: {
                [AccessTokenAuth.HeaderName]: AccessTokenAuth.GetHeaderValue(),
            },
        };

        axios
            .post(setPasswordUrl, data, config)
            .then((response) => {
                userMutation.mutate({});
            })
            .catch((error) => {
                console.log(error);
            });
    });
}
